<template>

    <span class="svg-container">
        <svg role="img">
            <use :xlink:href="'#' + id" />
        </svg>
    </span>

</template>

<script>
export default {
    name: 'icon',
    props: {
        id: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss">
</style>
